export default __webpack_public_path__ + "static/media/IMG-20210326-WA0034.cd07eb9e.jpg";